var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsMiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8782_51076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 0.277832C5.15614 0.277832 0.777344 4.65663 0.777344 10.0001C0.777344 11.7319 1.24443 13.4788 2.14453 14.9713L0.811561 18.9704C0.743126 19.1754 0.788737 19.4032 0.94828 19.5513C1.09639 19.7108 1.32422 19.7565 1.52926 19.6881L5.52828 18.3551C7.02079 19.2552 8.76776 19.7223 10.4996 19.7223C15.843 19.7223 20.2218 15.3435 20.2218 10.0001C20.2218 4.65663 15.843 0.277832 10.4996 0.277832Z",
    fill: "#78ECBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2222 10.0001C20.2222 15.3435 15.8434 19.7223 10.5 19.7223V0.277832C15.8434 0.277832 20.2222 4.65663 20.2222 10.0001Z",
    fill: "#48D38A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8782_51076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4444,
    height: 19.4444,
    fill: "white",
    transform: "translate(0.777344 0.277832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsMiniIcon);
export default __webpack_public_path__ + "static/media/SmsMiniIcon.9924e380662ade94fa4b7c9104af0747.svg";
export { ForwardRef as ReactComponent };